import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link, useNavigate } from "react-router-dom";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/DataTableContainer';

import { useDispatch, useSelector } from "react-redux";
import { fetchDriversDocumentsTypesData } from "../../store/drivers-documents-types/actions";

const DriversDocumentTypes = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data, loading, error } = useSelector(state => state.driversDocumentsTypes);

  useEffect(() => {
    dispatch(fetchDriversDocumentsTypesData());
  }, [dispatch]);

  const columns = useMemo(
    () => [
      {
        header: 'Type Name',
        accessorKey: 'typeName',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Description',
        accessorKey: 'typeDescription',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Is Upload?',
        accessorKey: 'is_upload_allowed',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Is Required?',
        accessorKey: 'is_required',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Front Required?',
        accessorKey: 'front_required',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Back Requried?',
        accessorKey: 'back_required',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Action',
        id: 'action',
        cell: ({ row }) => {
          const documentPermissionId = row.original?.documentPermissionId;
          return (
            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-success"
                onClick={() => navigate(`/drivers-documents-types/edit/${documentPermissionId}`)}
              >
                <i className="mdi mdi-pencil"></i> Edit
              </button>
            </div>
          );
        }
      },
    ],
    [navigate]
  );

  const totalRecords = data?.data?.length ?? 0;

  const transformedData = useMemo(() => {
    return data?.data?.map(item => {
      return {
        documentPermissionId: item.document_permission_id,
        documentTypeId: item.document_type_id,
        typeName: item.document_type_name || "N/A",
        typeDescription: item.document_type_description || "N/A",
        is_upload_allowed: item.is_upload_allowed == 1 ? 'YES' : 'NO' || "N/A",
        is_required: item.is_required == 1 ? 'YES' : 'NO' || "N/A",
        front_required: item.front_required == 1 ? 'YES' : 'NO' || "N/A",
        back_required: item.back_required == 1 ? 'YES' : 'NO' || "N/A",
      };
    });
  }, [data]);

  document.title = "Drivers Documents Types | Moeen";
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Home" breadcrumbItem="Documents Types (Drivers)" />
        <div className="float-end d-none d-md-block">
          <Link to="/drivers-documents-types/create"
            color="primary"
            className="btn btn-primary text-white waves-effect waves-light"
          >
            Add Documents Type
          </Link>
        </div>
        {loading ? (
          <Skeleton count={10} height={40} />
        ) : (
          <TableContainer
            columns={columns}
            data={transformedData || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder={`Looking for something? ${totalRecords} results loaded.`}
            pagination="pagination"
            paginationWrapper='dataTables_paginate paging_simple_numbers'
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        )}
      </div>
    </div>
  );
};

DriversDocumentTypes.propTypes = {
  t: PropTypes.any
};

export default DriversDocumentTypes;